import type { ReactNode } from "react";
import styles from "./FormField.module.css";

interface FormFieldProps {
  readonly label: string;
  readonly htmlFor: string;
  readonly error?: string;
  readonly hint?: string;
  readonly required?: boolean;
  readonly children: ReactNode;
  readonly className?: string;
}

export function FormField({
  label,
  htmlFor,
  error,
  hint,
  required,
  children,
  className,
}: FormFieldProps) {
  const hintId = hint ? `${htmlFor}-hint` : undefined;
  const errorId = error ? `${htmlFor}-error` : undefined;

  return (
    <div className={`${styles.field} ${className ?? ""}`}>
      <label htmlFor={htmlFor} className={styles.label}>
        {label}
        {required && <span className={styles.required} aria-hidden="true">*</span>}
      </label>
      {hint && (
        <p id={hintId} className={styles.hint}>{hint}</p>
      )}
      {children}
      {error && (
        <p id={errorId} role="alert" className={styles.error}>{error}</p>
      )}
    </div>
  );
}
